/* global mixpanel */
import React from "react"
import { connect } from "react-redux"
import * as actionCreators from "../redux/action_creators"
import TeamNav from "../components/layout/team_nav"
import { getItemsArray } from "../util/prop_utils"
import ButtonToolbar from "react-bootstrap/lib/ButtonToolbar"
import TeamDashButtonGroup from "../components/team_dash_button_group"
import TeamDashTagCollapseButtonGroup from "../components/team_tag_collapse_button_group"
import * as dateUtils from "../util/date_utils"
import * as timeUtils from "../util/time_utils"
import Dashboard from "./dashboard"
import TimeEntries from "../components/layout/time_entries"
import AdminDashboard from "../components/admin_dashboard"
import GA from "react-ga"

class TeamDashboard extends Dashboard {
    constructor(props) {
        super(props)

        this.renderButtonBar = this.renderButtonBar.bind(this)
        this.loadTeamIfNeeded = this.loadTeamIfNeeded.bind(this)

        this.state = {
            ...super.state,
            selectedTab: "admin",
        }
    }

    componentWillReceiveProps(nextProps) {
        this.loadTeamIfNeeded(nextProps)
    }

    loadTeamIfNeeded(props) {
        const { viewport, match } = props
        if (match && match.params.teamId !== viewport.teamId) {
            const teamId = match.params.teamId
            mixpanel.track("View team dashboard", { teamId })
            GA.event({category: "User", action: "View team dashboard: " + teamId})
            this.props.selectTeamDashboard(match.params.teamId)
            this.props.fetchCurrentHorizon()
        }
    }

    onTagCollapseChange = chosenCollapseMode => {
        this.props.setDashboardCollapse(chosenCollapseMode === "collapsed")
    }

    renderButtonBar() {
        const { collapse } = this.props.viewport
        const personalTabSelected = this.state.selectedTab === "personal"
        const display = this.props.viewport
            ? this.props.viewport.display
            : "list"
        if (personalTabSelected || !this.viewerIsTeamAdmin()) {
            return (
                <ButtonToolbar>
                    <TeamDashTagCollapseButtonGroup
                        display={collapse ? "collapsed" : "uncollapsed"}
                        onDisplayChange={this.onTagCollapseChange}
                    />
                </ButtonToolbar>
            )
        }

        return (
            <ButtonToolbar>
                <TeamDashButtonGroup
                    display={display}
                    onDisplayChange={this.onDisplayChange}
                />
            </ButtonToolbar>
        )
    }

    selectTab = selected => {
        const { profile } = this.props

        this.setState(
            {
                selectedTab: selected,
            },
            () => {
                this.props.setDashboardCollapse(selected === "admin")
                this.setTagReportUser(
                    selected === "personal"
                        ? this.profileToUser(profile)
                        : null,
                )
            },
        )
    }

    viewerIsTeamAdmin = () => {
        const { profile } = this.props
        const { teamId } = this.props.viewport
        const viewerTeamMembership = profile && profile.memberships[teamId]
        return (
            !!viewerTeamMembership &&
            viewerTeamMembership.accessLevel === "Admin"
        )
    }

    render() {
        const {
            selectedTeamMembership,
            viewport,
            profile,
            selectedTeamInvites,
            customer,
            ui: { paymentModalOpen, selectedSidebarTab, isLoading },
            isMobile,
        } = this.props

        const { selectedTab, tagReportUser } = this.state
        const { teamId, collapse } = viewport
        const { interval, increment, ...span } = this.props.viewport.range
        const personalTabSelected = selectedTab === "personal"
        // TODO: Multiteam
        const timeEntriesArray = getItemsArray(this.props.timeEntries).filter(
            t =>
                (t.teams || []).indexOf(teamId) > -1 &&
                (!personalTabSelected || t.userId === profile.id),
        )
        const timeEntries = this.props.timeEntries.items
        const incrementToUse = collapse ? increment : "Day"
        const teamsList = getItemsArray(this.props.teams)
        const runningEntries = [] // TODO - don't think runningEntries is used in team context - SB 8/2/2017
        const rollups = this.getRollups(timeEntriesArray, runningEntries)
        const title = dateUtils.dateRangeString(interval, span, {
            short: true,
            hideYear: interval !== "Month",
        })
        const totalHrs = timeUtils.msToHrsRounded(
            rollups.reduce((acc, r) => acc + r.total, 0),
        )
        const display = this.props.viewport
            ? this.props.viewport.display
            : "tag"
        const team = this.props.teams.items[teamId]
        const viewerIsTeamAdmin = this.viewerIsTeamAdmin()
        // if user is not team admin, set user to current user
        const reportUser = !viewerIsTeamAdmin
            ? this.profileToUser(profile)
            : tagReportUser

        const showByUser =
            viewerIsTeamAdmin &&
            (display === "member" && selectedTab !== "personal")
        return (
            <div>
                {!isMobile && viewerIsTeamAdmin && (
                    <TeamNav
                        selectedTab={selectedTab}
                        selectTab={this.selectTab}
                    />
                )}
                <div className="dashboard team-dashboard">
                    <div className="display-container">
                        {selectedTab === "admin" ? (
                            <AdminDashboard
                                handleRangeSelect={this.handleSelect}
                                title={title}
                                onClickBackward={this.moveBackward}
                                onClickForward={this.moveForward}
                                defaultSelectedOption={"Week"}
                                totalHrs={totalHrs}
                                renderButtonBar={this.renderButtonBar}
                                userId={profile.id}
                                timeEntriesArray={timeEntriesArray}
                                timeEntries={timeEntries}
                                timeEntryRollups={rollups}
                                tags={this.props.tags.items}
                                increment={incrementToUse}
                                createTimeEntry={this.props.createTimeEntry}
                                updateTimeEntry={this.props.updateTimeEntry}
                                teams={teamsList}
                                editTimeEntry={this.props.editTimeEntry}
                                isCollapsed={collapse}
                                showByUser={showByUser}
                                runningEntries={runningEntries}
                                viewport={this.props.viewport}
                                users={this.props.users.items}
                                selectedTeamInvites={selectedTeamInvites}
                                customer={customer}
                                trialEnd={customer.trialEnd}
                                paymentModalOpen={paymentModalOpen}
                                togglePaymentModal={this.togglePaymentModal}
                                selectedSidebarTab={selectedSidebarTab}
                                selectedTeamMembership={selectedTeamMembership}
                                isLoading={isLoading}
                            />
                        ) : (
                            <TimeEntries
                                handleRangeSelect={this.handleSelect}
                                title={title}
                                onClickBackward={this.moveBackward}
                                onClickForward={this.moveForward}
                                defaultSelectedOption={"Week"}
                                totalHrs={totalHrs}
                                renderButtonBar={this.renderButtonBar}
                                userId={profile.id}
                                timeEntriesArray={timeEntriesArray}
                                timeEntries={timeEntries}
                                timeEntryRollups={rollups}
                                tags={this.props.tags.items}
                                increment={incrementToUse}
                                createTimeEntry={this.props.createTimeEntry}
                                updateTimeEntry={this.props.updateTimeEntry}
                                teams={teamsList}
                                editTimeEntry={this.props.editTimeEntry}
                                isCollapsed={collapse}
                                showByUser={showByUser}
                                runningEntries={runningEntries}
                                viewport={this.props.viewport}
                                users={this.props.users.items}
                                selectedTeamMembership={selectedTeamMembership}
                                trialEnd={customer.trialEnd}
                            />
                        )}
                    </div>

                    {team && this.renderTagSideBar(team, timeEntriesArray)}

                    {this.renderModals(team, reportUser)}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return state
}

export default connect(
    mapStateToProps,
    actionCreators,
)(TeamDashboard)



// WEBPACK FOOTER //
// ./src/pages/team_dashboard.jsx